import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { t } from "@/i18n";
import { FormTextArea } from "@easy/ui/forms";


export default /*@__PURE__*/_defineComponent({
  __name: 'cCreatorProductForm',
  props: /*@__PURE__*/_mergeModels({
    placeholder: { default: t("shared.creator.form_placeholder") }
  }, {
    "prompt": { type: String },
    "promptModifiers": {},
    "errorMessage": {},
    "errorMessageModifiers": {},
  }),
  emits: ["update:prompt", "update:errorMessage"],
  setup(__props: any) {



const prompt = _useModel(__props, "prompt");

const errorMessage = _useModel(__props, "errorMessage");

function filedIsRequired() {
    if (!prompt.value) {
        errorMessage.value = t("shared.creator.prompt_required");
    } else if (prompt.value.length < 10) {
        errorMessage.value = t("shared.creator.prompt_some_more...");
    } else {
        errorMessage.value = "";
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(FormTextArea), {
    modelValue: prompt.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((prompt).value = $event)),
    label: _ctx.$t('shared.description'),
    placeholder: _ctx.placeholder,
    rows: 5,
    blur: filedIsRequired,
    error: errorMessage.value
  }, null, 8, ["modelValue", "label", "placeholder", "error"]))
}
}

})